import { t } from 'ttag';

import { Modal } from '@ui/Modal';
import { Button } from '@ui/Button';

import s from './FreePushUpInfoModal.sss';

interface Props {
  isOpen: boolean,
  limit: number,
  onClose: () => void,
}

export const FreePushUpInfoModal: React.FC<Props> = ({
  isOpen,
  limit,
  onClose,
}) => (
  <Modal
    className={s.modal}
    isOpen={isOpen}
    withClose={false}
  >
    <p className={s.description}>
      {t`Для вас доступно ${limit} безкоштовних підняттів в місяць на товари, що були додані/підняті більше 30 днів назад.`}
    </p>

    <p className={s.description}>
      {t`Безкоштовно підняти товар можна з картки товару.`}
    </p>

    <Button
      className={s.button}
      onClick={onClose}
    >
      {t`Добре`}
    </Button>
  </Modal>
);
